/*
 *
 * General Configurator reducer
 *
 */

import { ActionType } from 'typesafe-actions';
import * as actions from '../actions/general';
import { GeneralState } from './../types';
import ActionTypes from 'containers/Configurator/constants/general';
import { FurnitureEditorContext } from 'lib/constraintsChecker/FurnitureEditor';
import ActionTypesCabinet from 'containers/Configurator/constants/furniture';

type GeneralActions = ActionType<typeof actions>;

export const initialState: GeneralState = {
  customMode: false,
  context: FurnitureEditorContext.webShop,
  isVisiblePieceList: false,
  isVisibleViewer: true,
  colorsPanel: undefined, // undefined is no panel open
  shelfMode: false,
  openDoorsMode: false,
  showSchemaDimension: false,
};

function GeneralReducer(
  state: GeneralState = initialState,
  action: any,
): GeneralState {
  switch (action.type) {
    case ActionTypes.SET_CUSTOM_MODE:
      return { ...state, customMode: action.payload.value };
    case ActionTypes.SET_CONTEXT:
      return { ...state, context: action.payload.value };
    case ActionTypes.DISPLAY_PIECES_LIST:
      return { ...state, isVisiblePieceList: !state.isVisiblePieceList };
    case ActionTypes.DISPLAY_VIEWER:
      return { ...state, isVisibleViewer: action.payload.value };
    case ActionTypes.SET_COLORS_PANEL:
      return { ...state, colorsPanel: action.payload.value };
    case ActionTypes.SET_SHELVES_MODE:
      return { ...state, shelfMode: action.payload.value };
    case ActionTypes.OPEN_DOORS_MODE:
      return { ...state, openDoorsMode: action.payload.value };
    case ActionTypes.DISPLAY_DIMENSION:
      return { ...state, showSchemaDimension: action.payload.value };
    case ActionTypesCabinet.CABINET_UPDATE_SUCCESS:
      if (!action.payload.preview)
        return { ...state, showSchemaDimension: false };
      else return { ...state };
    default:
      return state;
  }
}

export default GeneralReducer;
